<template>
    <div style="min-height: 90vh">
        <div class="header pb-6" :style="[$bgColor(color.primary), backgroundImg]">
            <div class="container">
                <div class="header-body">
                    <div class="d-flex flex-wrap justify-content-center align-items-center pt-4">
                        <div v-if="hasDashboardOption && layout.dashboard_img_option === 0" class="col-12 text-center mt-4">
                            <img
                                class="rounded img-fluid img-center"
                                :src="image"
                                :alt="layout.dash_img.filename"
                            />
                        </div>
                        <div class="d-flex flex-wrap col-12 text-center pt-4">
                            <h1
                                :class="firstContentId ? 'my-4' : 'my-5'"
                                class="col-12"
                                :style="{color: color.secondary}"
                            >{{course.translation.name}}</h1>
                            <div class="col-12 mb-3" v-if="firstContentId && !publicUser">
                                <a :href="url">
                                    <PlayButton :color="color" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center p-1 generate-certificate mb-4">
                    <certificate-link
                        v-if="showCertificate"
                        class="mt-5"
                        :certificate="certificate"
                        :relation="{type: 'course', id: course.id}"
                    ></certificate-link>
                    <ProgressBar v-if="!publicUser" class="mb-0" :plan-id="plan" :course-id="course.id" />
                </div>
            </div>
        </div>
        <CourseContainer
            :class="isMobile"
            :color="color"
            :course="course"
            :plan="plan"
            :layout="layout"
            :forum="forum"
            :public-user="publicUser"
            :contents-api-url="contentsApiUrl"
            :public-lesson-urls="publicLessonUrls"
            :glossary="glossary"
            :wiki="wiki"
        />
    </div>
</template>

<script>
import BaseButton from '../argon/components/BaseButton';
import CourseContainer from './CourseComponents/CourseContainer';
import PlayButton from '../components/Common/PlayButton';
import ProgressBar from '../components/Common/ProgressBar';
import Breadcrumb from '../components/Common/Breadcrumb';
import CertificateLink from '../components/Certificate/CertificateLink';

export default {
    name: 'Course',

    components: {
        BaseButton,
        CourseContainer,
        PlayButton,
        ProgressBar,
        CertificateLink,
        Breadcrumb,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        course: {
            type: Object,
            required: true,
        },
        certificate: {
            type: Object,
        },
        plan: {
            type: Number,
            required: true,
        },
        forum: {
            type: Object | Number,
        },
        firstContentId: {
            type: Number | null,
        },
        layout: Object,
        publicUser: {
            type: Boolean,
            default: false,
        },
        contentsApiUrl: {
            type: String,
            default: '',
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
        /** Glossário (backlog#342): o curso tem termos visíveis e o recurso está ligado */
        glossary: {
            type: Boolean,
            default: false,
        },
        /** Wiki colaborativa (backlog#343): há wiki visível neste curso */
        wiki: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            courseProgress: null,
        };
    },
    computed: {
        image() {
            const { dash_img } = this.layout;
            if (dash_img.urls && dash_img.urls.original) {
                return dash_img.urls.original;
            }
            return `/storage/${dash_img.host}/original/${dash_img.original_file}`;
        },
        hasDashboardOption() {
            if (this.layout && Object.keys(this.layout).length !== 0 && this.layout.dash_img) {
                return this.layout.hasOwnProperty('dashboard_img_option');
            } return false;
        },
        backgroundImg() {
            if (
                this.hasDashboardOption &&
                this.layout.dashboard_img_option === 1
            ) {
                return {
                    backgroundImage: `url(${this.image})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                };
            }
        },
        isMobile() {
            if (this.$mq !== 'sm') {
                return 'nch--container';
            }
        },
        courseProgress() {
            if (!this.course.progress || this.course.progress === 0) {
                return 'course.start';
            }
            return 'course.continue';
        },
        url() {
            return `${this.course.id}/lesson/${this.firstContentId}`;
        },
        progress() {
            if (this.publicUser) {
                return 0;
            }
            return this.$store.getters.LOADED_PROGRESS;
        },
        showCertificate() {
            let certificateProgress = null;

            if (this.certificate && this.certificate.progress) {
                certificateProgress = parseInt(this.certificate.progress);
            }

            if (certificateProgress && this.courseProgress && this.courseProgress >= certificateProgress) {
                return true;
            }

            return false;
        },
    },
    methods: {
        async getCourseProgress() {
            const url = `/api/app/progress/plan/${this.plan}/course/${this.course.id}`;
            try {
                const res = await window.axios.get(url);
                this.courseProgress = res.data.progress;
            } catch (error) {
                console.error(error);
            }
        },
    },
    mounted() {
        this.$store.commit('SET_PLAN', this.plan);
        this.$store.commit('SET_COURSE', this.course);
        this.$store.commit('SET_FORUM', this.forum);
        this.getCourseProgress();
    },
};

</script>

<style  scoped>
.nch--progress-bar {
    height: 40px !important;
}
.nch--progress-bar--mobile {
    width: 100% !important;
    height: 18px !important;
}
.nch--progress-bar-center {
    text-align: center;
    text-align: -webkit-center;
}
.progress-bar-striped {
    background-size: 2rem 2rem;
}
.generate-certificate{
    background-color: #fff;
    border-radius: 0.375rem;
}
</style>
